import React, { useEffect } from 'react'
import ContactContent from '../components/contact/ContactContent'
import Navbar from '../common/Navbar'
import Footer from '../common/Footer'
import { useLocation } from 'react-router-dom'

const ContactUs = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, []);

  return (
    <div>
       <Navbar/>
       <ContactContent/>
       <Footer/>
    </div>
  )
}

export default ContactUs